import { render, staticRenderFns } from "./SmallSpinner.vue?vue&type=template&id=bf2117fa&scoped=true"
import script from "./SmallSpinner.vue?vue&type=script&lang=js"
export * from "./SmallSpinner.vue?vue&type=script&lang=js"
import style0 from "./SmallSpinner.vue?vue&type=style&index=0&id=bf2117fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2117fa",
  null
  
)

export default component.exports